import { useCallback } from 'react';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { handleEnrollSequenceSuccess, handleEnrollSequenceFailure } from 'crm-activity-creator-widgets/buttons/sequence/helpers/handleEnrollSequenceResponse';
export default function useEnrollSequence() {
  const sendEnrollMessage = useSendCrmMessageTopic(TOPIC_NAMES.SEQUENCE_ENROLLMENT);
  const enrollSequence = useCallback(({
    enrollment,
    sequenceName,
    err
  }) => {
    if (!enrollment || err) {
      return handleEnrollSequenceFailure({
        err
      });
    }
    const completedEnrollment = enrollment.set('userPlatform', 'CRM');
    handleEnrollSequenceSuccess({
      completedEnrollment,
      sequenceName
    });
    return sendEnrollMessage({
      sequenceName,
      enrollmentId: completedEnrollment.get('id'),
      objectId: completedEnrollment.get('vid')
    });
  }, [sendEnrollMessage]);
  return [enrollSequence];
}